<template>
  <v-data-table
      :headers="headers"
      :items="users_table_data || []"
      :xloading="!users_table_data"
  >
    <template v-slot:top>
      <v-toolbar flat color="white">
        <v-toolbar-title>Manage users</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-dialog v-model="create_dialog" max-width="650px" @click:outside="handleCloseNewDialog()">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
                color="secondary"
                dark
                class="mb-2"
                v-bind="attrs"
                v-on="on"
            >Create account
            </v-btn>
          </template>
          <v-card class="dialog-card">
            <v-card-title>
              <span class="dialog-card__header">Create account</span>
            </v-card-title>
            <v-form @submit="create_user()">
              <v-card-text>
                <v-text-field placeholder="email address" v-model="new_user_email">
                </v-text-field>
              </v-card-text>
              <v-btn class="custom-btn" color="secondary" @click="create_user()">
                Confirm
              </v-btn>
            </v-form>
          </v-card>
        </v-dialog>
      </v-toolbar>
    </template>
    <template v-slot:item.roles="{ item }">
      <ul>
        <li v-for="(role) of item.roles">{{ role.domain_name }} -
          {{ role.role_name }}
        </li>
      </ul>
    </template>
    <template v-slot:item.actions="{ item }">
      <v-dialog max-width="650px" @click:outside="handleCloseRolesDialog()">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
              v-bind="attrs"
              v-on:click="handleOpenRolesDialog(on, $event)"
              >
            <v-icon small> mdi-pencil</v-icon>
            ROLES
          </v-btn>
        </template>
        <v-card class="dialog-card">
          <v-card-title>
            <span class="dialog-card__header">Current roles</span>
          </v-card-title>
          <v-simple-table>
            <template v-slot:default>
              <thead>
              <tr>
                <th class="text-left">Domain</th>
                <th class="text-left">Role</th>
                <th class="text-left">Actions</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="association_item in item.roles" :key="association_item.name">
                <td>{{ association_item.domain_name }}</td>
                <td>{{ association_item.role_name }}</td>
                <td>
                  <v-btn @click="handleRemoveRoleClick(item, association_item)" fab dark x-small color="secondary">
                    <v-icon dark>mdi-delete</v-icon>
                  </v-btn>
                </td>
              </tr>
              </tbody>
            </template>
          </v-simple-table>
          <v-divider class="my-4"></v-divider>
          <v-card-title>
            <span class="dialog-card__header">Add role</span>
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="5">
                <v-select
                    :items="domains"
                    label="Select domain"
                    v-model="selectedDomain">
                </v-select>
              </v-col>
              <v-col cols="5">
                <v-select
                    :items="roles"
                    label="Select role"
                    v-model="selectedRole">
                </v-select>
              </v-col>
              <v-col class="action-button" cols="2">
                <v-btn @click="handleAddRoleClick(item)" fab dark x-small color="secondary">
                  <v-icon dark>mdi-plus</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-btn v-if="item.enabled" color="error" @click="disable_user(item)">
        <v-icon small> mdi-account-lock</v-icon>
        DISABLE
      </v-btn>
      <v-btn v-else color="success" @click="enable_user(item)">
        <v-icon small> mdi-account-check</v-icon>
        ENABLE
      </v-btn>
    </template>
  </v-data-table>
</template>

<script>
import {getDomains, getRoles, getUsersWithRoles, createRoleAssociation, deleteRoleAssociation,
        enableUser, disableUser, createUser } from '../../services/iam.service';
import moment from "moment";

export default {
  name: "UsersTable",
  props: [],
  data: () => ({
    headers: [
      {text: "email", value: 'email'},
      {text: "Created date", value: 'created_at'},
      {text: "Active", value: 'enabled'},
      {text: "Roles", value: 'roles'},
      {text: "Actions", value: 'actions', align: 'end'},
    ],
    domains: null,
    roles: null,
    selectedDomain: null,
    //rolesList: ['ADMIN', 'RoomUser', "Analyst"],
    selectedRole: null,
    users: null,
    search: '',
    new_user_email: '',
    create_dialog: false,
    roles_dialog: false,
  }),
  computed: {
    users_table_data: function () {
      if (this.users) {
        return this.users.map(d => {
          return {
              ...d,
              created_at: moment(d.created_at).format('LL'),
          };
        });
      } else {
        return this.users;
      }
    },
  },
  methods: {
    load_users: function () {
      getUsersWithRoles().then( users => {
        this.users = users;
      });
    },
    load_domains() {
      getDomains().then(domains => {
        this.domains = domains.map(d => {
          return {
            text: d.name,
            value: d.id,
          }
        });
      })
    },
    load_roles() {
      getRoles().then(roles => {
        this.roles = roles.map(r => {
          return {
            text: r.name,
            value: r.id,
          }
        });
      })
    },
    create_user: function () {
      if (this.new_user_email) {
        createUser(this.new_user_email).then(user => {
            this.load_users();
        })
        .catch(err => {
            alert("Creating user failed: " + err.response.data.error);
        });
        this.closeCreateDialog();
      }
    },
    closeCreateDialog: function () {
        this.create_dialog = false;
        this.new_user_email = "";
    },
    disable_user: function (user_item) {
      disableUser(user_item.username).then(_ => {
        user_item.enabled = false;
      })
      .catch(err => {
          alert("Enabling user failed: " + err.response.data.error);
      });
    },
    enable_user: function (user_item) {
      enableUser(user_item.username).then(_ => {
        user_item.enabled = true;
      })
      .catch(err => {
          alert("Disabling user failed: " + err.response.data.error);
      });
    },
    handleOpenRolesDialog(on, e) {
          this.load_domains();
          on.click(e);
    },
    handleCloseNewDialog() {
    },
    handleRemoveRoleClick(user, role) {

      confirm('Are you sure you want to delete this role?') &&
      deleteRoleAssociation(role.id).then(_ => {
          user.roles = user.roles.filter(r => r.id != role.id)
      })
      .catch(err => {
          alert("Removing role association failed: " + err.response.data.error);
      });
    },
    handleAddRoleClick(item) {
      if (this.selectedDomain != null && this.selectedRole != null) {
        createRoleAssociation(item.username, this.selectedDomain, this.selectedRole).then(
          ra => {
            item.roles.push({
              id: ra.id,
              role_id: ra.role_id,
              role_name: ra.role,
              domain_id: ra.domain_id,
              domain_name: ra.domain_name,
            });
          }
        )
        .catch(err => {
          alert("Adding role failed: " + err.response.data.error);
        })
        this.resetState();
      }
    },
    handleCloseRolesDialog(){
        this.resetState();
    },
    resetState(){
      this.selectedRole = null;
      this.selectedDomain = null;
    }
  },
  mounted() {
    if (!this.users) {
      this.load_users();
    }
    if (!this.roles) {
      this.load_roles();
    }
  },
}
</script>

<style scoped>
.action-button {
  display: flex;
  align-items: center;
  justify-content: center
}
</style>
